import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_download",
  "use": "icon_download-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon_download\"><path d=\"M42.86 20.989l-1.982-1.982a2.13 2.13 0 00-3.063.036L27.567 29.8V4.142A2.138 2.138 0 0025.424 2h-2.857a2.138 2.138 0 00-2.143 2.143V29.8l-10.24-10.748a2.145 2.145 0 00-3.062-.036l-1.981 1.982c-.84.83-.84 2.187 0 3.026L21.116 40H13a2 2 0 00-2 2v1a2 2 0 002 2h22a2 2 0 002-2v-1a2 2 0 00-2-2h-8.117L42.86 24.015c.84-.83.84-2.187 0-3.026z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol